
// 接单详情 findReceivedOrders, orderDetails[ReceivedOrder, CancelReceivedOrder]
import {getServiceProductOrderReceivedDetail} from '@/api/order.js'

export default {
    data() {
        return {
            isFinish: false,
            ifUser: false,
            productName: '',
            contactsTel: '',
            contactsName: '',
            optionsInfos: [],
            serviceAfterInfos: {},
            userInfos: {},
            organInfo: {},
            contactPatientsUsedFlag: 1,
            orderId: '', // 订单id
            orderSource: 3, // 订单来源1:运营系统 2:B端机构3:工作室-app 4:C端客户
            globalFlag: 0, // 是否可操作0:不可操作,1:可操作
            createUserPhone: '', // 注册手机号 2019-8-30 15:30 下单才有此字

        }
    },
    created() {
        let orderNo = PAGE_PARAMS.orderNo;
        if (orderNo) {
            getServiceProductOrderReceivedDetail(PAGE_PARAMS).then(r => {
                this.globalFlag = r.operableUsedFlag;
                this.contactPatientsUsedFlag = r.contactPatientsUsedFlag;
                // 子服务规格
                let specifications = r.serviceProductOrderContent;
                this.optionsInfos = specifications ? specifications : [];
                if (specifications && specifications.length > 0) {
                    this.optionsInfos = specifications.map(v => {
                        return {
                            nurseUserId: r.nurseUserId,
                            name: v.serviceProductSpecificationsName, // 服务产品规格名称
                            time: v.serviceTimesDesc,
                            id: v.serviceOrderId, // 服务订单id
                            orderSonNo: v.orderSonNo, // 服务订单子项编号
                            visitRecord: v.visitRecord, // 访视记录
                            details: v.specificationsContent, // 服务产品规格详情
                            state: v.serviceProductStatus, // 订单状态
                            currentProcess: v.currentProcess, // 当前流程按钮标识0:预约时间1:开始服务2:填写护理记录3:查看护理记录
                            operableUsedFlag: v.operableUsedFlag, // 是否可操作0:不可操作,1:可操作
                            firstServiceTime: v.firstServiceTime || '', // 服务订单子项服务时间
                            insuranceUsedFlag: v.insuranceUsedFlag, // 查看保险0:不可操作,1:可操作
                            isFirstService:v.isFirstFlag, // 是否是首次服务0:不是,1:是
                        }
                    })
                }
                let services = r.serviceProductOrderInfo; // 服务信息
                let serviceRemark = services.orderServiceContent; // 服务备注
                let skillLabel = ''; // 服务标签
                let address = ''; // 服务地址
                if (services) {
                    let {contactsCity, contactsArea, contactsAddress} = services;
                    address = contactsCity + '-' + contactsArea + '-' + contactsAddress;
                    // 技能标签
                    let skillLabelArr = services.serviceProductSkillLabelVO;
                    skillLabel = skillLabelArr && skillLabelArr.length > 0 ? skillLabelArr.map(v => v.skillsLabelName).join(',') : '';
                    let {
                        serviceProductName,
                        contactsTel,
                        contactsName,
                        createUserPhone,
                        orderNo,
                        orderId,
                        orderSource,
                        orderTotalAmountCNY,
                    } = services;
                    this.orderId = orderId;
                    this.orderSource = orderSource;
                    this.productName = serviceProductName;
                    this.contactsTel = contactsTel;
                    this.contactsName = contactsName;
                    this.createUserPhone = createUserPhone || '';
                    this.serviceAfterInfos = {
                        numbering: orderNo, // 订单编号
                        contacts: contactsName, // 联系人
                        contactInformation: contactsTel, // 联系方式
                        money: orderTotalAmountCNY, // 订单金额
                        address: address, // 服务地点
                        skillsLabel: skillLabel, // 服务标签
                    };
                }
                // 患者信息
                let userInformation = r.orderPatientInfoVO;
                if (userInformation) {
                    this.ifUser = true;
                    let {
                        symptomPhotos,
                        servicePatientName,
                        servicePatientSexDesc,
                        servicePatientAge,
                        patientSymptom,
                        beforeSymptom,
                    } = userInformation; // 病历
                    let medicalRecord = symptomPhotos && symptomPhotos.length > 0 ? symptomPhotos.split(',') : [];
                    this.userInfos = {
                        name: servicePatientName, // 姓名
                        sexDesc: servicePatientSexDesc, // 性别
                        age: servicePatientAge, // 年龄
                        symptoms: patientSymptom, // 症状
                        medicalHistory: beforeSymptom,
                        medicalRecord: medicalRecord, // 病历
                        remark: serviceRemark, // 备注
                    };
                }
            }).catch(_ => {
            });
        }

    }
}
